import React, { useMemo, useState } from 'react'

import * as seminarsApi from 'services/seminars'
import CourseItem from 'ui-component-library/components/DailyList/CourseItem'
import SidebarList from 'ui-component-library/components/DailyList/SidebarList'
import useLoadableList from '../useLoadableList'

const PER_PAGE = 10

const SEMINAR_TYPES = [
  'level-one',
  'online-level-one',
  'level-two',
  'level-four',
  'kids',
  'online-kids',
]

type Props = {
  nearMeText: string
  allText: string
  headlineText: string
}

function DailyCourseListContainer({
  nearMeText,
  allText,
  headlineText,
}: Props) {
  const [selectedFilter, setSelectedFilter] = useState('all')

  const fetchResults = useMemo(() => {
    if (selectedFilter === 'all') {
      return (page: number) =>
        seminarsApi.fetchSeminars({
          limit: PER_PAGE,
          page,
          seminarType: SEMINAR_TYPES,
        })
    } else {
      return (page: number) =>
        seminarsApi.fetchSeminarsNearMe({
          limit: PER_PAGE,
          page,
          seminarType: SEMINAR_TYPES,
        })
    }
  }, [selectedFilter])

  const { isLoading, results, onLoadMore } = useLoadableList(fetchResults)

  const filterOptions = [
    { value: 'all', label: allText },
    { value: 'nearMe', label: nearMeText },
  ]

  function handleChangeFilter(value: string) {
    setSelectedFilter(value)
  }

  return (
    <SidebarList
      headlineText={headlineText}
      isLoading={isLoading}
      filterOptions={filterOptions}
      selectedFilter={selectedFilter}
      onChangeFilter={handleChangeFilter}
      onLoadMore={onLoadMore}
    >
      {results &&
        results.map((result) => <CourseItem key={result.id} result={result} />)}
    </SidebarList>
  )
}

export default DailyCourseListContainer
